import { render } from "./AppManage.vue?vue&type=template&id=84f2a3da&scoped=true"
import script from "./AppManage.vue?vue&type=script&setup=true&lang=js"
export * from "./AppManage.vue?vue&type=script&setup=true&lang=js"

import "./AppManage.vue?vue&type=style&index=0&id=84f2a3da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84f2a3da"],['__file',"src/views/AppManage/AppManage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "84f2a3da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('84f2a3da', __exports__)) {
    api.reload('84f2a3da', __exports__)
  }
  
  module.hot.accept("./AppManage.vue?vue&type=template&id=84f2a3da&scoped=true", () => {
    api.rerender('84f2a3da', render)
  })

}


export default __exports__